import type { ReactNode } from "react";
import { Button } from "./Button";
import { Modal } from "./Modal";

export type ConfirmDialogProps = {
  open: boolean;
  title: ReactNode;
  description: ReactNode;
  /** Libellé du bouton de confirmation : un verbe, « Retirer ». */
  confirmLabel: ReactNode;
  /** `danger` pour un retrait ou une rétrogradation. */
  tone?: "default" | "danger";
  /** Envoi en cours : le bouton de confirmation tourne, l'annulation reste. */
  pending?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

/**
 * Demande de confirmation avant un geste qu'on ne défait pas d'un clic :
 * retirer un membre, rétrograder un administrateur, supprimer un logo.
 */
export function ConfirmDialog({
  open,
  title,
  description,
  confirmLabel,
  tone = "default",
  pending = false,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  return (
    <Modal
      open={open}
      onClose={onCancel}
      title={title}
      footer={
        <>
          <Button variant="ghost" onClick={onCancel} disabled={pending}>
            Annuler
          </Button>
          <Button
            variant={tone === "danger" ? "danger" : "primary"}
            onClick={onConfirm}
            loading={pending}
          >
            {confirmLabel}
          </Button>
        </>
      }
    >
      <p>{description}</p>
    </Modal>
  );
}
